module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"LOGOUT":"Déconnexion","PROFILE":"Modifier le profil","PASSWORD":"Changer mot de passe"},"en":{"LOGOUT":"Logout","PROFILE":"Profile edit","PASSWORD":"Change password"}}')
  delete Component.options._Ctor
}
